import * as React from 'react';
import { Icon } from 'semantic-ui-react';
import * as InfoCardApi from '~/Api/InfoCard';
import { formatUserMonthYear } from '~/Date';
export var resolveIconName = function (tagType) {
    switch (tagType) {
        case InfoCardApi.TagType.brand:
            return 'pills';
        case InfoCardApi.TagType.market:
            return 'map marker alternate';
        case InfoCardApi.TagType.source:
            return 'clipboard outline';
        case InfoCardApi.TagType.yearMonth:
            return 'calendar outline';
        case InfoCardApi.TagType.type:
            return 'sticky note outline';
        default:
            return undefined;
    }
};
export var resolveTagName = function (tagType) {
    switch (tagType) {
        case InfoCardApi.TagType.brand:
            return 'Výrobce';
        case InfoCardApi.TagType.market:
            return 'Trh';
        case InfoCardApi.TagType.source:
            return 'Zdroj';
        case InfoCardApi.TagType.yearMonth:
            return 'Kalendářní měsíc';
        case InfoCardApi.TagType.type:
            return 'Aktualita';
        default:
            return null;
    }
};
export var Tag = function (_a) {
    var tag = _a.tag;
    return (<>
		<Icon name={resolveIconName(tag.type)}/>
		{tag.type === InfoCardApi.TagType.yearMonth ? formatUserMonthYear(tag.date, ['cs-CZ']) : tag.title}
	</>);
};
export var TagLink = function (_a) {
    var InfoCardsLink = _a.InfoCardsLink, tag = _a.tag;
    return (<InfoCardsLink tag={tag}>
		<a className='descriptionItem' data-testid={"".concat(tag.type, "-tag")}>
			<Tag tag={tag}/>
		</a>
	</InfoCardsLink>);
};
